import { Card, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

// Images
import ActiveImage from "~/assets/images/activeAccount.png";
import theme from "~/components/Common/Theme";

const styledName = "Terms";

export const StyledTermsBackground = styled("div", { name: styledName })({
  "&": {
    position: "relative",
    backgroundImage: `url(${ActiveImage})`,
    width: "100vw",
    height: "100vh",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
});

export const StyledTermsContent = styled(Card, {
  name: styledName,
})({
  "&": {
    height: "fit-content",
    width: "1200px",
    minWidth: "800px",
    borderRadius: "20px",
    backgroundColor: "#ffffff",
    opacity: "0.9",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "30px 100px",
    margin: "40px auto",
  },
});

export const StyledTermHeader = styled(Typography, { name: styledName })({
  "&": {
    textAlign: "center",
    fontSize: "2rem",
    fontFamily: "'Andika', sans-serif",
    height: "30px",
    color: theme.palette.primary.main,
  },
});

export const StyledTermItem1 = styled(Typography, { name: styledName })({
  "&": {
    width: "100%",
    textAlign: "start",
    height: "30px",
    fontSize: "1.8rem",
    fontWeight: "600",
    color: theme.palette.primary.main,
  },
});

export const StyledTermItem2 = styled(Typography, { name: styledName })({
  "&": {
    width: "100%",
    textAlign: "start",
    height: "30px",
    marginLeft: "20px",
    fontWeight: "600",
  },
});

export const StyledTermText = styled(Typography, { name: styledName })({
  "&": {
    width: "100%",
    textAlign: "start",
    margin: "5px 0px 5px 40px",
  },
});
